import { Model } from '@psyomics/surveyjs-core';
import { SurveyJs } from '@psyomics/ui-components';
import { useEffect, useRef, useState } from 'react';

import { ReferralRequestSurvey } from '../hooks/use-referral-request-survey';

const usePrepareSurvey = ({
  model,
  survey,
  fetching,
  reviewMode,
}: {
  model: Model;
  survey?: ReferralRequestSurvey;
  fetching: boolean;
  reviewMode: boolean;
}) => {
  const initialSkipDone = useRef(false);
  const [answersPopulated, setAnswersPopulated] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!initialSkipDone.current && answersPopulated) {
      initialSkipDone.current = true;
      if (!reviewMode) SurveyJs.navigateToLastAnsweredQuestion(model);
      setReady(true);
    }
  }, [model, answersPopulated, reviewMode]);

  useEffect(() => {
    if (survey && !fetching) {
      model.mergeData(survey.answers ? JSON.parse(survey.answers) : {});
      setAnswersPopulated(true);
    }
  }, [survey, fetching, model]);

  return ready;
};

export { usePrepareSurvey };
